// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2nIue","inner":"Form_inner__2UuOm","range":"Form_range__3Yhi9","name":"Form_name__1t6TD","actions":"Form_actions__1dDVb"};